import React from 'react';
function OpenAccount() {
    return ( 
          <div className="container p-5 mt-5">
            <div className='row text-center'>
                <h1 className='mt-3 mb-2 fs-3 mb-4'>Open a Zerodha account</h1>
                <p className='mb-5 fs-5'>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
                <button className='p-3 border-none fs-4 border-0 rounded-1 fs-4'  style={{width:"20%",margin:"auto",padding:"0.75rem",backgroundColor:"#387ed1",color:"white"}}>Sign up for free</button>
            </div>
        </div>
    );
}

export default OpenAccount;